<template>
    <div>
        <dynamic-form :formConfig="formConfig" v-model="form" @submit="submit"></dynamic-form>
    </div>
</template>
<script>
import '@/components/dynamic-form';
export default {
    data() {
        return {
            form: {},
            formConfig: {
                inline: true,
                labelPosition: "right",
                labelWidth: "",
                size: "small",
                statusIcon: true,
                formItemList: [
                    {
                        span: 12,
                        type: "input",
                        key: "name",
                        label: "姓名",
                        disable: false,
                        readonly: false,
                        value: "李四",
                        placeholder: "请输入姓名",
                        rules: [
                            {
                                required: true,
                                message: "不能为空",
                                trigger: "blur"
                            },
                            {
                                min: 1,
                                max: 8,
                                type: "string",
                                message: "长度在1~8个字符",
                                trigger: "blur"
                            },
                            {
                                pattern: "^[\\w\\u4e00-\\u9fa5-_]+$",
                                message: "正则验证失败:^[\\w\\u4e00-\\u9fa5-_]+$",
                                trigger: "blur"
                            }
                        ]
                    },
                    {
                        span: 12,
                        label: '日期',
                        key: 'bizdate',
                        type: 'date',
                        placeholder: '请选择日期',
                        rules: {
                            required: true, message: '不能为空', trigger: 'blur'
                        }
                    },
                    {
                        span: 12,
                        label: '数字',
                        key: 'amount',
                        type: 'input',
                        subtype: 'number',
                        value: '11',
                        placeholder: '请输入数字',
                        rules: {
                            required: true, message: '不能为空', trigger: 'blur'
                        }
                    },
                    {
                        span: 12,
                        type: "select",
                        label: "下拉单选",
                        value: "",
                        disabled: false,
                        multiple: false,
                        placeholder: "请选择",
                        rules: [{
                                required: true,
                                message: "不能为空",
                                trigger: "blur"
                            }
                        ],
                        key: "like",
                        options: [
                            {
                                value: "suanzao",
                                label: "蒸酸枣",
                                disabled: false
                            },
                            {
                                value: "yaogao",
                                label: "蒸羊羔",
                                disabled: false
                            },
                            {
                                value: "mantou",
                                label: "蒸馒头",
                                disabled: false
                            }
                        ]
                    },
                    {
                        span: 12,
                        type: "select",
                        label: "下拉单选(动)",
                        value: "",
                        disabled: false,
                        multiple: false,
                        placeholder: "请选择",
                        rules: [],
                        key: "remoteLike",
                        dicType: 'USER_LABLE',
                        optionsUrl: "/dynamic/getDicData"
                    },
                    {
                        span: 12,
                        type: "select",
                        label: "下拉多选",
                        value: [],
                        disabled: false,
                        multiple: true,
                        placeholder: "请选择",
                        rules: [],
                        key: "likes",
                        options: [
                            {
                                value: "suanzao",
                                label: "蒸酸枣",
                                disabled: false
                            },
                            {
                                value: "yaogao",
                                label: "蒸羊羔",
                                disabled: false
                            },
                            {
                                value: "mantou",
                                label: "蒸馒头",
                                disabled: false
                            }
                        ]
                    },
                    {
                        span: 12,
                        type: "select",
                        label: "下拉多选(动)",
                        value: [],
                        disabled: false,
                        multiple: true,
                        placeholder: "请选择",
                        rules: [],
                        key: "remoteLikes",
                        dicType: 'USER_LABLE',
                        optionsUrl: "/dynamic/getDicData"
                    },
                    {
                        span: 12,
                        type: "radio",
                        label: "单选",
                        value: "",
                        button: false,
                        border: false,
                        key: "gender",
                        options: [
                            {
                                value: "1",
                                label: "男",
                                disabled: false
                            },
                            {
                                value: "0",
                                label: "女",
                                disabled: false
                            }
                        ],
                    },
                    {
                        span: 12,
                        type: "radio",
                        label: "动态单选",
                        value: "",
                        button: false,
                        border: false,
                        key: "asynDic",
                        dicType: 'USER_LABLE',
                        optionsUrl: "/dynamic/getDicData"
                    },
                     {
                        span: 12,
                        label: '树型下拉多选',
                        key: 'area3',
                        type: 'treeSelect',
                        multiple: true,
                        value: ['nanchang','yichun'],
                        clearable: true,
                        options: [
                            {
                                label: '江西',
                                value: 'jiangxi',
                                children: [
                                    {
                                        label: '南昌',
                                        value: 'nanchang',
                                        disabled: true
                                    },
                                    {
                                        label: '宜春',
                                        value: 'yichun',
                                    },
                                    {
                                        label: '鹰潭',
                                        value: 'yintan',
                                    },
                                ]
                            },
                        ],
                        rules: {
                            required: true, message: '不能为空', trigger: 'blur'
                        }
                    },
                    {
                        type: "switch",
                        label: "开关",
                        appearance: "switch",
                        value: false,
                        key: "reopen"
                    },
                    {
                        span: 12,
                        type: "checkbox",
                        label: "多选",
                        key: "ctyy",
                        value: [],
                        rules: [
                            {
                                required: true,
                                message: "必填项",
                                trigger: "blur"
                            }
                        ],
                        options: [
                            {
                                value: "0",
                                label: "南昌",
                                disabled: false
                            },
                            {
                                value: "2",
                                label: "深圳",
                                disabled: false
                            }
                        ]
                    },
                    {
                        span: 12,
                        type: "checkbox",
                        label: "动态多选",
                        key: "asynCheckBox",
                        value: [],
                        rules: [
                            {
                                required: true,
                                message: "必填项",
                                trigger: "change"
                            }
                        ],
                        dicType: 'USER_LABLE',
                        optionsUrl: "/dynamic/getDicData"
                    },
                    {
                        span: 12,
                        type: "input",
                        key: "desc",
                        label: "描述",
                        disable: false,
                        subtype: 'textarea',
                        readonly: false,
                        value: "",
                        placeholder: "请输入描述",
                        rules: [
                            {
                                required: true,
                                message: "不能为空",
                                trigger: "blur"
                            }
                        ]
                    }
                ]
            },
        }
    },
    methods: {
        submit(v) {
            console.log(v)
        }
    }
}
</script>
